var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppConfig from '../../config/config';
import { mapProducts, mapFilters, mapMeta, mapSorts } from './mapper';
import { fetchSearchspring } from './api';
export class SearchspringSearchProvider {
    constructor() {
        this.products = [];
        this.filters = [];
        this.meta = null;
        this.sortOptions = [];
    }
    search(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, options = {}) {
            var _a;
            const { page = 1, pageSize = AppConfig.page.defaultSize, sort = 'relevance', filters, } = options;
            try {
                const data = yield fetchSearchspring({
                    q: query,
                    page,
                    pageSize,
                    sort,
                    filters,
                });
                // Handle merchandising redirects
                if ((_a = data.merchandising) === null || _a === void 0 ? void 0 : _a.redirect) {
                    window.location.href = data.merchandising.redirect;
                    return;
                }
                this.products = mapProducts(data.results || []);
                this.filters = mapFilters(data.facets || [], filters);
                this.meta = mapMeta(data);
                this.sortOptions = mapSorts(data);
            }
            catch (error) {
                console.error('[Searchspring] Search failed:', error);
                throw new Error(`Searchspring search failed: ${error instanceof Error ? error.message : String(error)}`);
            }
        });
    }
    getProducts() {
        return this.products;
    }
    getFilters() {
        return this.filters;
    }
    getMeta() {
        if (!this.meta) {
            throw new Error('No search has been performed yet');
        }
        return this.meta;
    }
    getSortOptions() {
        return this.sortOptions;
    }
}
